import Collection from 'ol/Collection';
import type BaseLayer from 'ol/layer/Base';
import type { CollectionEvent } from 'ol/Collection';
import { fromEventPattern, Observable } from 'rxjs';
import { unByKey } from 'ol/Observable';

export function collectionEvents$(
  coll: any
) {
  return fromEventPattern(
    handler => coll.on('add', handler),
    (_handler, key) => unByKey(key)
  );
}

export function collectionRemovals$(
  coll: any
) {
  return fromEventPattern(
    handler => coll.on('remove', handler),
    (_handler, key) => unByKey(key)
  );
}



